import { useField } from 'informed';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

import './styles/formFieldStyles.css';

const TextAreaAutosize = ({ className, maxRows, minRows, ...props }) => {
  const { render, informed, fieldState } = useField({
    fieldType: 'text',
    ...props,
  });
  const { error, touched, value } = fieldState;
  const { defaultValue, ...rest } = informed;
  const statusClass =
    value && !error && touched ? 'success' : value && error && 'error';
  return render(
    <Fragment>
      <TextareaAutosize
        {...rest}
        aria-invalid={!!error}
        className={`custom-field ${className} ${statusClass || ''}`}
        id={props.field}
        maxRows={maxRows}
        minRows={minRows}
      />
      {error && <small className="text-red-3">{error}</small>}
    </Fragment>,
  );
};

TextAreaAutosize.defaultProps = {
  className: '',
  maxRows: 22,
  minRows: 2,
};

TextAreaAutosize.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
};

export default TextAreaAutosize;
